export default "<app-headertwo></app-headertwo>\n\n<router-outlet  (activate)=\"onActivate($event)\"></router-outlet>\n<app-footer></app-footer>"